<template>
  <v-navigation-drawer v-model="drawer" app clipped left>
    <v-list nav dense>
      <template v-for="(item) of items">
        <template v-if="routeShow(item)">

          <template v-if="routeSchema(item)">
            <template>
              <v-list-item color="primary" :to="{ name: item.name }">
                <v-list-item-icon>
                  <v-icon>{{ item.meta.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ item.meta.title }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </template>

          <template v-else-if="Array.isArray(item.children)">
            <ListGroup :item="item"/>
          </template>

        </template>

      </template>
    </v-list>
    <template v-slot:append>
      <div class="px-3 pb-8 pt-4 text-center">
        <v-menu top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn block color="primary" v-bind="attrs" v-on="on">
              Создать
              <v-icon v-text="'mdi-chevron-bottom'"></v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
                target="_blank"
                v-for="(item, index) in realizationLinks"
                :key="index"
                :href="item.path"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Router from "@/utils/Router"

export default {
  props: {
    items: Array
  },
  data: () => ({
    drawer: true,
    realizationLinks: Router.addCreateButton
  }),
  components: {
    HelperSidebar: () => import('@/components/pageUnits/TestHelperSidebar'),
    ListGroup: () => import('@/components/pageUnits/ListGroup')
  }
}
</script>